import React from "react";
import { Navigate } from "react-router-dom";
import ensureAuthenticatedStorage, { useEnsureAuthenticated } from "../contexts/ensureAuthenticated";
import { RoleArr } from "@/models/role.model";
import { userPermissions } from "@/contexts/userPermissions";
import { PermissionEnum } from "@/utils/permissionEnum";
import { User } from "@/models/user.model";
import { useToast } from "@chakra-ui/react";
import Cookies from "js-cookie";

interface ProtectedRouteProps {
  component: React.ComponentType<any>;
  roles?: RoleArr[];
  routePermissions?: PermissionEnum | PermissionEnum[];
  [key: string]: any; 
}

function hasRequiredPermissions(
  user: User,
  routePermissions: PermissionEnum | PermissionEnum[]
): boolean {
  const permissions = userPermissions(user) || [];
  const requiredPermissions = Array.isArray(routePermissions)
    ? routePermissions
    : [routePermissions];

  return requiredPermissions.some((permission) =>
    permissions.includes(permission)
  );
}

export default function ProtectedRoute({
  component: Component,
  routePermissions,
  ...rest 
}: ProtectedRouteProps) {
  const { user } = useEnsureAuthenticated();
  const toast = useToast();

  if (!user) {
    return <Navigate to="/login" />;
  }

  if (routePermissions && !hasRequiredPermissions(user, routePermissions)) {
    toast({
      title: "Erro de permissão",
      description: "Usuário não é administrador",
      status: "error",
      duration: 5000,
      isClosable: true,
    });

    Cookies.remove("session");
    Cookies.remove("refreshToken");
    
    const { removeAuthentication } = ensureAuthenticatedStorage.getState();
    removeAuthentication();

    
    return <Navigate to="/" />;
  }

  
  return <Component {...rest} />;
}
